export const getCountryFlagEmoji = countryCode => {
  const REGIONAL_SYMBOLS_OFFSET = 127397;
  const upperCaseCountryCode = countryCode.toUpperCase();

  return String.fromCodePoint(
    ...[
      REGIONAL_SYMBOLS_OFFSET + upperCaseCountryCode.charCodeAt(0),
      REGIONAL_SYMBOLS_OFFSET + upperCaseCountryCode.charCodeAt(1),
    ]
  );
};
